import type { DesktopShellStore, PendingAnnotation } from '@/lib/desktop-shell/store';
import { showPanelView } from '@/lib/side-panel/panel-tabs';

export type SelectionActions = {
  annotateSelection: (selection: PendingAnnotation) => void;
  askSelectionInSideChat: (content: string, autoSubmit?: boolean) => void;
};

/**
 * Pure store-backed actions for acting on a chat/file/terminal selection: start
 * a pending annotation, hand the selection to the side-chat panel. Extracted from inline handlers in `DesktopShell`.
 */
export function createSelectionActions({ store }: { store: DesktopShellStore }): SelectionActions {
  return {
    annotateSelection(selection) {
      const { setPendingAnnotation, setPendingAnnotationText } = store.getState();
      setPendingAnnotation(selection);
      setPendingAnnotationText('');
    },
    askSelectionInSideChat(content, autoSubmit = false) {
      const { setSideChatPrompt, setPanelTabs, setSidePanelOpen } = store.getState();
      setSideChatPrompt({
        autoSubmit,
        id: crypto.randomUUID(),
        text: autoSubmit ? `Give me more details about this selection:\n\n${content}` : content,
      });
      setPanelTabs((tabs) => showPanelView(tabs, 'chat'));
      setSidePanelOpen(true);
    },
  };
}
